import React from 'react';
import ReactSelect from 'react-select';

const Select = props => {
  const styles = {
    control: baseStyles => ({
      ...baseStyles,
      background: 'var(--bs-body-bg)',
      color: 'var(--bs-body-color)',
      borderColor: 'var(--bs-border-color)'
    }),
    menuPortal: baseStyles => ({
      ...baseStyles,
      zIndex: 1069
    }),
    menu: baseStyles => ({
      ...baseStyles,
      background: 'var(--bs-body-bg)',
      color: 'var(--bs-body-color)'
    }),
    menuList: (baseStyles, state) => ({
      ...baseStyles,
      background: state.isFocused ? 'var(--bs-blue)' : 'var(--bs-body-bg)',
      color: 'var(--bs-body-color)'
    }),
    singleValue: baseStyles => ({
      ...baseStyles,
      color: 'var(--bs-body-color)'
    }),
    multiValue: baseStyles => ({
      ...baseStyles,
      color: 'var(--bs-body-color)'
    }),
    option: (baseStyles, state) => ({
      ...baseStyles,
      background: state.isFocused ? 'var(--bs-primary-border-subtle)' : 'var(--bs-body-bg)',
      color: 'var(--bs-body-color)'
    })
  };
  return <ReactSelect {...props} styles={styles} />;
};

export default Select;
